var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.173 11.173 10.5 12 10.5C12.827 10.5 13.5 11.173 13.5 12C13.5 12.827 12.827 13.5 12 13.5ZM12 8.50002C10.07 8.50002 8.49999 10.07 8.49999 12C8.49999 13.93 10.07 15.5 12 15.5C13.93 15.5 15.5 13.93 15.5 12C15.5 10.07 13.93 8.50002 12 8.50002ZM12.2197 16.9976C7.91369 17.0976 5.10469 13.4146 4.17269 11.9956C5.19869 10.3906 7.78269 7.10462 11.7807 7.00262C16.0697 6.89362 18.8947 10.5856 19.8267 12.0046C18.8017 13.6096 16.2167 16.8956 12.2197 16.9976ZM21.8677 11.5026C21.2297 10.3906 17.7057 4.81662 11.7297 5.00362C6.20169 5.14362 2.98669 10.0136 2.13269 11.5026C1.95569 11.8106 1.95569 12.1896 2.13269 12.4976C2.76169 13.5946 6.16169 18.9996 12.0247 18.9996C12.1067 18.9996 12.1887 18.9986 12.2707 18.9966C17.7977 18.8556 21.0137 13.9866 21.8677 12.4976C22.0437 12.1896 22.0437 11.8106 21.8677 11.5026Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.7f4221d36210cb6c11fe0b6a9b62bae0.svg";
export { ForwardRef as ReactComponent };